var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paywall-overlay" }, [
    _c("div", { staticClass: "paywall-card" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "paywall-actions" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary paywall-btn font-bold",
            on: {
              click: function($event) {
                _vm.$emit("onBuy")
              }
            }
          },
          [_vm._m(2)]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-upgrade-premium paywall-btn",
            on: {
              click: function($event) {
                _vm.$emit("onUpgrade")
              }
            }
          },
          [
            _c("i", {
              staticClass: "fa fa-diamond",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v("\n        プレミアムに登録\n      ")
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-left mr-t-10" }, [
        _vm._v("※「動画を購入」を押すと、Stripeの決済画面へ移動します。")
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paywall-lock" }, [
      _c("i", { staticClass: "fa fa-lock", attrs: { "aria-hidden": "true" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "paywall-title" }, [
      _vm._v("\n      この動画を視聴するには "),
      _c("br"),
      _vm._v("\n      動画の購入 "),
      _c("br"),
      _vm._v("\n      またはプレミアムのご登録が必要です\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", {
        staticClass: "fa fa-shopping-cart",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v("\n          動画を購入\n        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b042753", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b042753","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/PaywallOverlay.vue
// module id = null
// module chunks = 